module.exports = __webpack_public_path__ + "img/culture.45d35c96.png";